import { FC } from 'react';
import styled from 'styled-components';
import { BaseLayout } from '../Layout/BaseLayout';
import { IBaseLayoutProps } from '../Layout/IBaseLayoutProps';

const LayoutElement = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  flex-flow: column nowrap;
  overflow: auto;

  & > * {
    margin-bottom: 30px;
  }
`;

type IProps = IBaseLayoutProps;

export const TwoRowLayout: FC<IProps> = props => {
  return (
    <BaseLayout {...props} data-testid="TwoRowLayout">
      <LayoutElement>{props.children}</LayoutElement>
    </BaseLayout>
  );
};
